import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoAsa: CultureInfo = {
  name: 'asa',
  displayName: 'Kipare',
  iso3LanguageCode: 'asa',
  iso2LanguageCode: 'asa',
  ietfLanguageTag: 'asa',
  parent: null
};
